import axios, { AxiosError } from 'axios';
import customConfig from 'src/config';
import { errorHandle, ErrorInfo } from '@Utils/request';
import { v4 } from 'uuid';
import { isInUIC } from '@Utils/common';

const uicRequest = axios.create({
  timeout: customConfig.ui.request.timeout,
  headers: {
    'Content-Type': 'application/json',
  },
});

let orgId = '';
export function updateOrgId(id: string) {
  orgId = id;
}

uicRequest.interceptors.request.use(
  (config: any) => {
    const id = v4();
    if (isInUIC()) {
      //CAS customer header need add prefix 'tmv1-',then it can be transferred to bff by sp
      const uicToken = localStorage.getItem('uic-token') || '';
      if (uicToken) {
        config.headers['uic-token'] = uicToken;
        config.headers['x-source-domain'] = window.top?.location.origin;
      }
      config.headers['x-trace-id'] = id;
    }
    config.headers['x-request-id'] = id;
    if (!config.headers['x-org-id']) {
      config.headers['x-org-id'] = orgId ? orgId : 'all';
    }

    return config;
  },
  (error) => Promise.reject(error)
);

uicRequest.interceptors.response.use(
  (res) => {
    if (res.request.responseType === 'blob') {
      return Promise.resolve(res);
    }
    if (200 <= res.status && res.status < 300) {
      return Promise.resolve(res.data);
    } else {
      return Promise.reject(res.data);
    }
  },
  (error) => {
    const { response } = error as AxiosError;
    if (response) {
      const errorInfo: ErrorInfo = {
        status: response.status,
        data: response.data,
        url: response.config.url || 'unknown url',
        traceId:
          (response.config.headers?.['x-request-id'] as string) ||
          'unknown traceId',
        message: error.message,
      };
      errorHandle(response.status, errorInfo);
      return Promise.reject(response);
    } else {
      return Promise.reject(error);
    }
  }
);

export default uicRequest;
